import { useMemo, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { useReveal } from "./useReveal";

const filters = ["All", "Installation", "Refinishing", "Herringbone", "Completed Work"];

const Gallery = ({ gallery }) => {
  const [active, setActive] = useState("All");
  const [ref, revealClass] = useReveal();
  const visible = useMemo(() => active === "All" ? gallery : gallery.filter((item) => item.category === active), [active, gallery]);

  return (
    <section className="gallery-section section-wrap" id="work" ref={ref} data-testid="gallery-section">
      <div className={`section-heading gallery-heading ${revealClass}`}><div><p className="eyebrow">Our work</p><h2>Real flooring projects.</h2></div><p className="heading-aside">Photos from real flooring projects in PA, DE and NJ.</p></div>
      <div className="filter-row" role="group" aria-label="Filter projects">
        {filters.map((filter) => <button className={active === filter ? "filter-button is-active" : "filter-button"} type="button" onClick={() => setActive(filter)} key={filter} data-testid={`gallery-filter-${filter.toLowerCase().replace(/\s+/g, "-")}`}>{filter}</button>)}
      </div>
      <div className="gallery-grid">
        {visible.map((item, index) => (
          <figure className={`gallery-card gallery-card-${(index % 3) + 1}`} key={item.id || item.image_url} data-testid={`gallery-project-${index + 1}`}>
            <div className="gallery-image-wrap"><img src={item.image_url} alt={item.alt} loading="lazy" /><a href="#contact" aria-label={`Ask about ${item.title}`} data-testid={`gallery-project-link-${index + 1}`}><ArrowUpRight size={18} /></a></div>
            <figcaption><div><span className="gallery-category">{item.category}</span><h3>{item.title}</h3><p className="gallery-detail">{item.room_type} · {item.finish}</p></div><span className="gallery-location">{item.location}</span></figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
